import { CREATIVE_STATUSES } from '~/utils/constants';
import _ from 'lodash';
import boolean from 'boolean';
import ImageHelper from '~/components/image-helper/ImageHelper.vue';
import * as defaults from './../defaults';

const margin = 5;

export default {
  props: {
    pictures: Object,
    mobileView: Boolean,
    defaultImage: String,
    facebookPage: Object,
    landingPage: Object,
    isCtaVisible: Boolean,
    isTimeline: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ImageHelper,
  },
  data() {
    const parser = document.createElement('a');

    return {
      currentImage: 0,
      carouselMargin: 0,
      mediaLength: _.size(_.get(this.pictures, 'media')) + 1,
      defaults,
      parser,
      isHtmlVideoSupported: !!document.createElement('video').canPlayType,
      navImageHover: 0,
    };
  },
  methods: {
    changeImage(direction) {
      const elem = this.$el.querySelector('.card-list');
      const carouselWidth = elem.clientWidth;
      const child = elem.children[0];
      const childWidth = child.clientWidth || 300;

      switch (direction) {
        case 'next':
          // First to second
          if (this.currentImage === 0 && this.currentImage !== this.mediaLength) {
            this.carouselOffset = (childWidth - ((carouselWidth - childWidth) / 2)) + margin;
          // Middle
          } else if (this.currentImage > 0 && this.currentImage < this.mediaLength - 2) {
            this.carouselOffset += childWidth + margin;
          // To last
          } else {
            this.carouselOffset += (childWidth - ((carouselWidth - childWidth) / 2)) + margin;
          }
          this.currentImage += 1;
          break;
        default:
          // Second to first
          if (this.currentImage === 1) {
            this.carouselOffset = 0;
          // Middle
          } else if (this.currentImage > 1 && this.currentImage < this.mediaLength - 1) {
            this.carouselOffset -= childWidth + margin;
          // Last to previous
          } else {
            this.carouselOffset -= (childWidth - ((carouselWidth - childWidth) / 2)) + margin;
          }
          this.currentImage -= 1;
          break;
      }
      elem.style.transform = `translate3d(-${this.carouselOffset}px, 0px, 0px)`;
      this.calculateButtonSize();
    },
    calculateButtonSize() {
      const elemNext = this.$el.querySelector('.next-image');
      const elemPrev = this.$el.querySelector('.prev-image');
      const elem = this.$el.querySelector('.card-list');
      const carouselWidth = elem.clientWidth;
      const padding = -(elem.parentElement.clientWidth - carouselWidth);
      const child = elem.children[0];
      const childWidth = child.clientWidth || 300;

      if (this.currentImage === 0) {
        elemNext.style.width = `${carouselWidth - (padding / 2) - childWidth - margin}px`;
      } else if (this.currentImage > 0 && this.currentImage < this.mediaLength - 1) {
        const width = `${(carouselWidth - padding - childWidth - (2 * margin)) / 2}px`;
        elemPrev.style.width = width;
        elemNext.style.width = width;
      } else {
        elemPrev.style.width = `${carouselWidth - (padding / 2) - childWidth - margin}px`;
      }
    },
    onImageLoaded() {
      this.$emit('loaded');
    },
    description(pic) {
      return pic.description !== '' || this.inStatus || this.isTimeline ?
        pic.description :
        this.$t('pos.campaign.creatives.adv-builder.description');
    },
    caption(pic) {
      return pic.name !== '' || this.inStatus || this.isTimeline ?
        pic.name :
        this.$t('pos.campaign.creatives.adv-builder.caption');
    },
    resetCarousel() {
      this.currentImage = 0;
      this.carouselOffset = 0;
      const elem = this.$el.querySelector('.card-list');
      elem.style.transform = 'translate3d(0px, 0px, 0px)';
      this.$nextTick(() => {
        this.calculateButtonSize();
      });
    },
    showVideo(file) {
      const filename = _.get(file, 'path', '');
      const isVideo = boolean(_.get(file, 'isVideo', false)) || _.get(file, 'content_type', '').startsWith('video/');
      const isSupported = filename && !['avi', 'qt'].includes(filename.split('.').pop());
      return this.isHtmlVideoSupported && isVideo && isSupported;
    },
    isGif(filename) {
      if (filename) {
        const ext = filename.split('.').pop();
        return ['gif'].includes(ext);
      }
      return false;
    },
    hoverNavImage() {
      this.navImageHover = 1;
    },
    leaveNavImage() {
      this.navImageHover = 0;
    },
  },
  computed: {
    landingPageHostname() {
      this.parser.href = _.get(this.landingPage, 'link', '#');
      return this.parser.hostname;
    },
    inStatus() {
      return this.pictures.status === CREATIVE_STATUSES.READY ||
        this.pictures.status === CREATIVE_STATUSES.APPROVED;
    },
  },
  watch: {
    pictures: {
      handler: function watchPictures(val) {
        const size = _.size(_.get(val, 'media')) + 1;
        if (this.mediaLength !== size) {
          this.mediaLength = size;
          this.resetCarousel(this.mobileView);
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.calculateButtonSize();
    });
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/creative-preview/carousel/Carousel.js